import * as yup from 'yup';

import * as MESSAGES from '../messages';

export const UserDetailsSchema = yup.object().shape({
  firstname: yup.string().trim().required(MESSAGES.REQUIRE_MESSAGE),
  lastname: yup.string().trim().required(MESSAGES.REQUIRE_MESSAGE),
  job_role: yup.string(),
  profile_image_url: yup.string(),
  username: yup.string().email(MESSAGES.EMAIL_MESSAGE).trim().required(MESSAGES.REQUIRE_MESSAGE),
  current_password: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .when('new_password', (newPassword: string | undefined, schema) =>
      newPassword && newPassword.length > 0
        ? schema.required(MESSAGES.REQUIRE_MESSAGE)
        : schema.optional(),
    ),
  new_password: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .optional()
    .min(6, MESSAGES.PASSWORD_SHORT_MESSAGE(6))
    .max(20, MESSAGES.PASSWORD_LONG_MESSAGE(20)),
  confirmPassword: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .when('new_password', (newPassword: string | undefined, schema) =>
      newPassword && newPassword.length > 0
        ? schema
            .required(MESSAGES.REQUIRE_MESSAGE)
            .oneOf([yup.ref('new_password')], 'Passwords must match')
        : schema.optional(),
    ),
});

export const AddTeamMemberSchema = yup.object().shape({
  email: yup.string().email(MESSAGES.EMAIL_MESSAGE).trim().required(MESSAGES.REQUIRE_MESSAGE),
  role: yup.string().trim().required(MESSAGES.REQUIRE_MESSAGE),
});
